$(document).ready(function(){
    var paid_services_order_form_submitted = false;
    $('.paid_service_quantity').on('change', function(){
        if($(this).val() <= 0) {
            $(this).val(1);
        }
        var service_count = $(this).val();
        var price = $(this).data('price');
        var service_final_price = service_count * price;
        if(service_count >= 5 && service_count < 10){
            service_final_price = service_final_price - (service_final_price * 10) / 100;
        }
        else if(service_count >= 10){
            service_final_price = service_final_price - (service_final_price * 20) / 100;
        }
        if(service_final_price % 100 !== 0) {
            service_final_price = (parseInt(service_final_price / 100) + 1) * 100;
        }
        var paid_service_item = $(this).closest('.paid_service_item');
        service_final_price = service_final_price > 0 ? service_final_price: 0;
        paid_service_item.find('.paid_service_total_price').text(service_final_price);
        paid_service_item.find('.paid_service_total_price_input').val(service_final_price);
        if( paid_service_item.find('.paid_service_checkbox').prop('checked')) {
            setPaidServicesTotalPrice();
        }
    });
    $('.paid_service_quantity').on('keydown', function(e){
        if(!((e.keyCode > 96 && e.keyCode < 106)
            || (e.keyCode > 47 && e.keyCode < 58)
            || e.keyCode == 8)) {
            return false;
        }
    });

    $('.paid_service_checkbox').on('change', function(){
        setPaidServicesTotalPrice();
        var service_type_checkbox = $(this).parents('.service_type_block').find('.service_type_checkbox_block .service_type_checkbox');
        if(!$(this).parents('.service_type_services').find('input.paid_service_checkbox:not(:checked)').length){
            service_type_checkbox.prop('checked', true);
        }
        else {
            service_type_checkbox.prop('checked', false);
        }
        if(paid_services_order_form_submitted){
            if($('#paid_services_total_price').val() > 0){
                $('.submit-paid-services-order-form').find('.total_price_required_error_message').addClass('hidden');
            }
            else {
                $('.submit-paid-services-order-form').find('.total_price_required_error_message').removeClass('hidden');
            }
        }
    });

    $('#paid_service_open_modal_button').click(function(){
        paid_services_order_form_submitted = true;
        if($('#paid_services_total_price').val() <= 0){
            $('#submit-paid-services-order-form').find('.total_price_required_error_message').removeClass('hidden');
        }
        else {
            $('#submit-paid-services-order-form').find('.total_price_required_error_message').addClass('hidden');
            var paid_services_titles = {};
            $('.service_type_block').each(function(service_type_key, service_type){
                var service_type_title = $(service_type).find('.service_type_title').text();
                if($(service_type).find('.service_type_checkbox').prop('checked')){
                    paid_services_titles[service_type_title] = $('#all_text').val();
                }
                else {
                    $(service_type).find('.paid_service_checkbox:checked').each(function(service_key, service){
                        var paid_service_item = $(service).closest('.paid_service_item');
                        var paid_service_title = paid_service_item.find('.paid_service_title_container').text().trim();
                        if(!paid_service_item.find('.paid_service_quantity').prop('disabled')){
                            paid_service_title += ' (' + paid_service_item.find('.paid_service_quantity').val() + ')';
                        }
                        if(paid_services_titles.hasOwnProperty(service_type_title)){
                            paid_services_titles[service_type_title] += ', ' + paid_service_title;
                        }
                        else {
                            paid_services_titles[service_type_title] = paid_service_title;
                        }

                    });
                }
            });

            $('.loading_pop_up').show();
            var url = $(this).attr('data-url');
            var total_price = $('#paid_services_total_price').val();
            var data = {
                paid_services_titles : JSON.stringify(paid_services_titles),
                total_price: total_price
            }
            $.post(url, data, function(result){
                $('.loading_pop_up').hide();
                $('#hs_default_modal').modal('show')
                    .find('.modal-content')
                    .html(result);
            });
        }
    });

    $('.paid_services_btn[type="reset"]').on('click', function(){
        $('.paid_service_item').find('.paid_service_total_price').each(function(key, value){
            var paid_service_item = $(value).closest('.paid_service_item');
            var original_price = paid_service_item.find('.paid_service_quantity').data('price');
            paid_service_item.find('.paid_service_total_price').text(original_price);
            paid_service_item.find('.paid_service_total_price_input').text(original_price);
            $('#paid_services_total_price').val(0);
            $('.paid-services-total-price').find('.total-count').text(0);
        });
    });

    $('.service_type_title_block').on('click', function(){
        $(this).find('img.arrow').toggleClass('up');
        $($(this).data('block')).slideToggle();
    });

    $('.service_type_checkbox').on('change', function(){
        var service_title_block = $(this).parents('.service_type_block').find('.service_type_title_block');
        var toggled_block = $(service_title_block.data('block'));
        if($(this).prop('checked')){
            service_title_block.find('img.arrow').addClass('up');
            toggled_block.find('input.paid_service_checkbox').prop('checked', true).trigger('change');
            toggled_block.slideDown();
        }
        else {
            service_title_block.find('img.arrow').removeClass('up');
            toggled_block.find('input.paid_service_checkbox').prop('checked', false).trigger('change');
            toggled_block.slideUp();
        }
    });

});

function setPaidServicesTotalPrice(){
    var price = 0;
    $('.paid_service_checkbox:checked').each(function(key, value){
        price += parseInt($(value).closest('.paid_service_item').find('.paid_service_total_price').text());
    });
    price = price > 0 ? price: 0;
    $('.paid-services-total-price').find('.total-count').text(price);
    $('#paid_services_total_price').val(price);
}